<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>{{ tituloDialog }}</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>
      <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
        <mat-icon>fullscreen</mat-icon>
      </button>
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <br>
</mat-toolbar>

<div mat-dialog-actions class="entrega-dialog-actions">

  <button mat-raised-button color="warn" (click)="onExcluirEntrega()">
    <mat-icon>delete</mat-icon>
    Excluir Entrega
  </button>
    <button mat-raised-button color="primary" matTooltip="Salvar" (click)="onYesClick()">
    <mat-icon>save</mat-icon>
    Salvar
  </button>
</div>

<div mat-dialog-content>
  <form [formGroup]="entregaForm">
    <div class="row">
      <mat-form-field class="col-md-5 col-sm-6 col-xs-12 form-group" appearance="outline">
        <mat-label>Local de Entrega</mat-label>
        <input matInput formControlName="localEntrega" maxlength="250">
      </mat-form-field>

      <mat-form-field class="col-md-4 col-sm-6 col-xs-12 form-group" appearance="outline">
        <mat-label>Nome do Destinatário</mat-label>
        <input matInput formControlName="nomeDestinatario" maxlength="150">
      </mat-form-field>

      <mat-form-field class="col-md-3 col-sm-6 col-xs-12 form-group" appearance="outline">
        <mat-label>CPF do Destinatário</mat-label>
        <input matInput formControlName="cpfDestinatario" mask="000.000.000-00" placeholder="000.000.000-00">
      </mat-form-field>

      <mat-form-field class="col-md-5 col-sm-6 col-xs-12 form-group" appearance="outline">
        <mat-label>Setor do Destinatário</mat-label>
        <input matInput formControlName="setorDestinatario" maxlength="150">
      </mat-form-field>

      <mat-form-field class="col-md-3 col-sm-6 col-xs-12 form-group" appearance="outline">
        <mat-label>Data de Entrega</mat-label>
        <input matInput [matDatepicker]="dataEntregaPicker" formControlName="dataEntrega">
        <mat-datepicker-toggle matSuffix [for]="dataEntregaPicker"></mat-datepicker-toggle>
        <mat-datepicker #dataEntregaPicker></mat-datepicker>
      </mat-form-field>
    </div>
  </form>
</div>

